import { type ECommerceProduct, type PreOrderInfo } from '@hooks-api/types/dataModel/products'
import { isAfter, parseISO, startOfDay } from 'date-fns'

/**
 * 商品是否處於「有效預購」狀態：已開啟預購、有出貨日、且尚未過出貨日。
 * is_pre_ordered 僅代表有無開啟，不含時效。
 */
export const isPreOrderActive = (preOrderInfo: PreOrderInfo | undefined): boolean => {
  if (!preOrderInfo?.is_pre_ordered || !preOrderInfo.delivery_date) return false
  return !isAfter(startOfDay(new Date()), parseISO(preOrderInfo.delivery_date))
}

export const findPreOrderProduct = (products: (ECommerceProduct | undefined)[]): ECommerceProduct | undefined => {
  return products.find(product => isPreOrderActive(product?.pre_order_info))
}

/**
 * 取傳入商品中最晚的有效預購出貨日（yyyy-MM-dd）；無有效預購品時回 undefined。
 */
export const getLatestPreOrderDeliveryDate = (products: (ECommerceProduct | undefined)[]): string | undefined => {
  return products
    .filter(product => isPreOrderActive(product?.pre_order_info))
    .map(product => product?.pre_order_info?.delivery_date)
    .filter((deliveryDate): deliveryDate is string => !!deliveryDate)
    .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())[0]
}
